import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var fonts = theme.fonts,
  text = theme.text;
export var banner = /*#__PURE__*/css(["min-height:", ";padding:0 ", ";text-align:center;background-color:var(--topBannerBgColor,var(--neutral-white-base));display:flex;align-items:center;justify-content:center;"], pxToRem(36), pxToRem(6));
var baseCopyStyles = /*#__PURE__*/css(["p,a,span{margin:0;font-family:", ";font-weight:", ";font-size:", ";line-height:", ";", "}a{white-space:nowrap;text-decoration:underline;}"], fonts.PRIMARY_SEMIBOLD.family, fonts.PRIMARY_SEMIBOLD.weight, pxToRem(text.BODY.XS.fontSize), pxToRem(24), mediaQuery({
  min: minBreakpoints.XS
}, css(["&{font-size:", ";}"], pxToRem(text.BODY.SM.fontSize))));
export var longCopy = /*#__PURE__*/css(["", " ", ""], baseCopyStyles, mediaQuery({
  max: maxBreakpoints.S
}, css(["display:none;"])));
export var shortCopy = /*#__PURE__*/css(["", " ", ""], baseCopyStyles, mediaQuery({
  min: minBreakpoints.M
}, css(["display:none;"])));
export var copyColor = {
  ['Dark']: css(["&,a{color:var(--neutral-black-base);}"]),
  ['Light']: css(["&,a{color:var(--neutral-white-base);}"])
};